import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button, TextField, Grid, Select, MenuItem, InputLabel, FormControl } from '@mui/material';
import CursoCard from '../../components/Cursos/CursoCard';
import { listarCampanhas } from '../../services/campanhaService';
import useAuth from '../../hooks/useAuth';

const FormCurso = ({ onSubmit, cursoInicial }) => {
 const { user } = useAuth();
 const [campanhas, setCampanhas] = useState([]);
 const [formData, setFormData] = useState({
   nome: cursoInicial?.nome || '',
   campanhaId: cursoInicial?.campanhaId || '',
   instituicaoId: user?.instituicaoId,
   descricao: cursoInicial?.descricao || '',
   duracao: cursoInicial?.duracao || '',
   turno: cursoInicial?.turno || '',
   vagas: cursoInicial?.vagas || '',
   areasAfinidade: [
     { area: "Matemática", pesoAfinidade: 3 },
     { area: "Física", pesoAfinidade: 2 },
     { area: "Tecnologia", pesoAfinidade: 3 }
   ]
 });

 useEffect(() => {
   const fetchCampanhas = async () => {
     try {
       const response = await listarCampanhas();
       setCampanhas(response.campanhas || []);
     } catch (error) {
       console.error('Erro ao carregar campanhas:', error);
       setCampanhas([]);
     }
   };

   fetchCampanhas();
 }, []);

 const handleChange = (e) => {
   const { name, value } = e.target;
   setFormData(prev => ({
     ...prev,
     [name]: value
   }));
 };

 const handleSubmit = (e) => {
   e.preventDefault();
   onSubmit({
     ...formData,
     vagas: parseInt(formData.vagas),
     campanhaId: parseInt(formData.campanhaId)
   });
 };

 return (
   <form onSubmit={handleSubmit}>
     <Grid container spacing={2}>
       {cursoInicial && <CursoCard curso={cursoInicial} />}
       
       <Grid item xs={12}>
         <TextField
           label="Nome do Curso"
           name="nome"
           value={formData.nome}
           onChange={handleChange}
           fullWidth
           required
         />
       </Grid>

       <Grid item xs={12}>
         <TextField
           label="Descrição"
           name="descricao"
           value={formData.descricao}
           onChange={handleChange}
           multiline
           rows={4}
           fullWidth
         />
       </Grid>

       <Grid item xs={12} md={6}>
         <TextField
           label="Duração"
           name="duracao"
           value={formData.duracao}
           onChange={handleChange}
           fullWidth
         />
       </Grid>

       <Grid item xs={12} md={6}>
         <TextField
           label="Turno"
           name="turno"
           value={formData.turno}
           onChange={handleChange}
           fullWidth
         />
       </Grid>

       <Grid item xs={12} md={6}>
         <TextField
           label="Vagas"
           name="vagas"
           type="number"
           value={formData.vagas}
           onChange={handleChange}
           fullWidth
         />
       </Grid>

       <Grid item xs={12}>
         <FormControl fullWidth required>
           <InputLabel>Campanha</InputLabel>
           <Select
             name="campanhaId"
             value={formData.campanhaId}
             onChange={handleChange}
             label="Campanha"
           >
             {campanhas.map((campanha) => (
               <MenuItem key={campanha.id} value={campanha.id}>
                 {campanha.nome}
               </MenuItem>
             ))}
           </Select>
         </FormControl>
       </Grid>

       <Grid item xs={12}>
         <Button type="submit" variant="contained" color="primary">
           {cursoInicial ? 'Atualizar Curso' : 'Criar Curso'}
         </Button>
       </Grid>
     </Grid>
   </form>
 );
};

FormCurso.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  cursoInicial: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    nome: PropTypes.string,
    descricao: PropTypes.string,
    duracao: PropTypes.string,
    turno: PropTypes.string,
    vagas: PropTypes.number,
    campanhaId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), // Added this line
    campanha: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      nome: PropTypes.string,
    }),
  }),
};

export default FormCurso;